import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSelectedProgramContextSelectedId, clearSelectedProgramContext } from "features/selected-context";

interface Props {
  children: React.ReactNode;
}

const JobSeekerContextProvider: React.FC<Props> = ({ children }: Props) => {
  const dispatch = useDispatch();
  const { programId } = useParams<{ programId: string }>();

  useEffect(() => {
    dispatch(setSelectedProgramContextSelectedId(programId));
    if (!programId) {
      dispatch(clearSelectedProgramContext());
    }
  }, [programId, dispatch]);

  return <>{children}</>;
};

export default JobSeekerContextProvider;
